import React from 'react'
import { Link } from 'react-router-dom'
import { Space, Typography } from 'antd'
import { isNil, map } from 'lodash'
import PropTypes from 'prop-types'

const IngredientConflictingErrors = ({ errors }) =>
  map(errors, (ingredient, index) => (
    <Typography.Paragraph key={index}>
      <Space>
        <Typography.Text strong>{ingredient.name}</Typography.Text>
        {!isNil(ingredient) && (
          <>
            <Typography.Text>conflicts with:</Typography.Text>

            <Link to={`/ingredients/${ingredient.originIngredientId}`}>
              {ingredient.originIngredientName}
            </Link>

            <Typography.Text>conflict type: {ingredient.type}</Typography.Text>
          </>
        )}
      </Space>
    </Typography.Paragraph>
  ))

IngredientConflictingErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default IngredientConflictingErrors
